import apiClient from "./apiClient";

const labResultsApi = {
  // Subir laboratorio a nivel de sucursal (nuevo)
  upload: async (branchId, file, period) => {
    const formData = new FormData();
    formData.append("branchId", branchId);
    formData.append("month", period.month);
    formData.append("year",  period.year);
    formData.append(
      "applicationDate",
      `${period.year}-${String(period.month).padStart(2, "0")}`
    );
    formData.append("file", file, file.name);
    const res = await apiClient.post("/lab-results/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  // Por sucursal (nuevo)
  getPeriodsForBranch: async (branchId) => {
    const res = await apiClient.get(`/lab-results/branches/${branchId}/periods`);
    return res.data;
  },

  // Por empresa (backward compat — analytics existentes)
  getPeriodsForCompany: async (companyId) => {
    const res = await apiClient.get(`/lab-results/${companyId}/periods`);
    return res.data;
  },
};

export default labResultsApi;
